import { MargaretProvider } from '@tymate/margaret';
import AppProvider from 'containers/AppProvider';
import Callback from 'containers/Auth/Callback';
import Login from 'containers/Auth/Login';
import AuthenticationProvider from 'containers/AuthenticationProvider';
import External from 'containers/External';
import ExternalDocument from 'containers/ExternalDocument';
import GraphQLProvider from 'containers/GraphQLProvider';
import RoutesProvider from 'containers/RoutesProvider';
import 'core-js/stable';
import 'flag-icons/css/flag-icons.css';
import React, { Suspense } from 'react';
import 'react-app-polyfill/ie11';
import ReactDOM from 'react-dom';
import { pdfjs } from 'react-pdf/dist/esm/entry.webpack';
import 'react-phone-number-input/style.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import 'sanitize.css';
import 'sanitize.css/forms.css';
import 'sanitize.css/typography.css';
import { createGlobalStyle } from 'styled-components';
import 'typeface-montserrat';
import { fontStyles, theme } from 'ui';
import App from './App';
import './i18n';
import './index.css';
import * as serviceWorker from './serviceWorker';
// import {
//   SENTRY_DSN,
//   SENTRY_ENVIRONMENT,
//   SENTRY_RELEASE,
//   SENTRY_TRACES_SAMPLE_RATE,
//   SENTRY_TRACING_ORIGIN,
// } from './constants';
import { ResizeObserver as ResizeObserverPolyfill } from '@juggle/resize-observer';

const GlobalStyles = createGlobalStyle`
  body {
    ${fontStyles.body}
  }

  h1 {
    ${fontStyles.h1}
  }

  h2 {
    ${fontStyles.h2}
  }

  h3 {
    ${fontStyles.h3}
  }
`;

// Not supported in older browsers, so gotta use a polyfill
window.ResizeObserver = window.ResizeObserver || ResizeObserverPolyfill;

// Sentry.init({
//   dsn: SENTRY_DSN,
//   integrations: [
//     new BrowserTracing({
//       tracingOrigins: [SENTRY_TRACING_ORIGIN],
//       routingInstrumentation: Sentry.reactRouterV6Instrumentation(
//         React.useEffect,
//         useLocation,
//         useNavigationType,
//         createRoutesFromChildren,
//         matchRoutes,
//       ),
//       beforeNavigate: replaceNavigation,
//     }),
//     new posthog.SentryIntegration(
//       posthog,
//       'paprwork',
//       8,
//       'sentry.nestor.tools',
//     ),
//   ],
//   environment: SENTRY_ENVIRONMENT,
//   release: SENTRY_RELEASE,
//   // Set tracesSampleRate to 1.0 to capture 100%
//   // of transactions for performance monitoring.
//   // We recommend adjusting this value in production
//   tracesSampleRate: parseFloat(SENTRY_TRACES_SAMPLE_RATE),
// });

function replaceNavigation(context) {
  return {
    ...context,
    // You could use your UI's routing library to find the matching
    // route template here. We don't have one right now, so do some basic
    // parameter replacements.
    name: window.path || window.location.pathname,
  };
}
// const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);

const url = `//cdn.jsdelivr.net/npm/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;
pdfjs.GlobalWorkerOptions.workerSrc = url;

ReactDOM.render(
  <React.StrictMode>
    <Suspense fallback={<div />}>
      <MargaretProvider theme={theme}>
        <AuthenticationProvider>
          <BrowserRouter>
            <GraphQLProvider>
              <AppProvider>
                <RoutesProvider>
                  <GlobalStyles />
                  {/* <SentryRoutes> */}
                  <Routes>
                    {/* <Route path="login" element={<Login />} /> */}
                    <Route path="login" element={<Login />} />
                    <Route
                      path="requests/:tenantApiId/:apiId/documents/:documentApiId"
                      element={<ExternalDocument />}
                    />
                    <Route
                      path="requests/:tenantApiId/:apiId"
                      element={<External />}
                    />
                    <Route path="callback/login" element={<Callback />} />
                    <Route path="*" element={<App />} />
                  </Routes>
                  {/* </SentryRoutes> */}
                </RoutesProvider>
              </AppProvider>
            </GraphQLProvider>
          </BrowserRouter>
        </AuthenticationProvider>
      </MargaretProvider>
    </Suspense>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
